import { parseISO, isWithinInterval } from 'date-fns';
import { PROMOTION_STATUS_ACTIVE } from '../../../components/TargetedOffers/Components/Banner/Constants';

export const getDisableDay = ({ promotions, date, unavailable, promotionSelected }) => {
	const { valid, status, criteriaToSearchSelection = {}, criteria = [] } = promotions || {};
	const { startDate = [] } = criteriaToSearchSelection || {};

	if (status !== PROMOTION_STATUS_ACTIVE) return unavailable;

	if (!valid || !promotionSelected || criteria.length == 0) {
		return unavailable;
	}
	if (!date) {
		return true;
	}

	const dateDay = parseISO(date);

	const isValidDate = startDate.some((val) => {
		const [start, end] = val.split('~');
		const innerRangeStart = parseISO(start);
		const innerRangeEnd = parseISO(end);

		return isWithinInterval(dateDay, { start: innerRangeStart, end: innerRangeEnd });
	});
	return !isValidDate;
};
